// Stepts for homepage
const hiringSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: '🙋<br>Začínáme',
        description: '<b>Na této stránce máš přehled nad všemi aktuálními uchazeči. </b>',
        position: 'center',
        showButtons: true,
    },

},
{
    element: ".datatable-top-bar",
    popover: {
        title: '🥳<br>Díky timeline máš přehled nad celým průběhem náborového procesu',
        description: 'Mezi jednotlivými fázemi náboru si můžeš překlikávat a <b>prohlédnout si uchazeče, kteří právě danou fází náboru procházejí.</b> V červeném kolečku <div class="badge badge-timeline-red"><span>3</span></div> vidíš jejich celkový počet.',
        position: 'bottom-center',
        showButtons: true,
    },
},
{
    element: ".top-corner-add-button",
    popover: {
        title: ' ',
        description: '<b>Nové uchazeče </b> můžeš přidat tady.',
        position: 'left',
        showButtons: true,
    },

},
{
    element: ".table",
    popover: {
        title: '🧑<br>Přehled uchazečů',
        description: 'Ke každému uchazeči si můžeš přidávat štítky, zkušenosti, ★ hodnocení a vlastní poznámky.',
        position: 'bottom-center',
        showButtons: true,
    },

},
{
    element: "#filter_with_job-hiring",
    popover: {
        title: ' ',
        description: '<b>Ve výchozím stavu vidíš všechny uchazeče bez ohledu na pracovní pozici. </b>Pro bližší prozkoumání se hodí filtr podle pracovní pozice. Snadno tak například zjistíš, jak probíhá nábor kritické pozice.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".filters-bar",
    popover: {
        title: '💪<br>Pokročilé filtrování',
        description: '<b>Takto si můžeš snadno prohlédnout jen uchazeče, kteří splňují všechna tvá kritéria.</b> Např. jen uchazeči s určitým štítkem, které jsi ohodnotila na 2★. <br><br>Vyhledávání ti pak zase pomůže rychle najít uchazeče podle jména',
        position: 'bottom',
        showButtons: true,
    },

},

{
    element: ".action-td",
    popover: {
        title: ' ' ,
        description: '<b>Dokonalý kandidát? ✨</b> Zde ho můžeš rovnou poslat do předvýběru. Stačí namísto "Noví uchazeči" zvolit "Předvýběr".',
        position: 'bottom-right',
        showButtons: true,
    },


},
{
    element: ".edit",
    popover: {
        className: 'image-popover',
        title: '<a href="../hiring?profile=12" target="_blank" title="Více"><img src="/images/guide-hiring-1.png"></a>',
        description: 'Kliknutím na ikonu <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg> si otevřeš vše o daném uchazeči. Můžeš zde cokoli editovat, např. přidat novou poznámku ✍️',
        position: 'bottom-right',
        showButtons: true,
    },
    onNext: () => {
        $('.modal .close').trigger('click');
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);

    }
},
{
    element: ".datatable-td",
    popover: {
        title: '🚫<br>Hromadné zamítnutí uchazečů',
        description: '<b>Stačí označit nezajímavé uchazeče,</b> vyplnit obsah zprávy a Onboardio ji za tebe zašle všem takto vybraným uchazečům. <br><br>Text e-mailu si zvolíš podle sebe nebo můžeš použít tebou předpřipravenou šablonu a <b>ušetřit tak mnoho času</b> ⏱️<br><br>  <i>Hromadně lze provádět i další akce.</i>',
        position: 'right',
        showButtons: true,
    },
    onNext: () => {
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);

    }
},
// {
//     element: ".align-self-start",
//     popover: {
//         title: ' ',
//         description: 'Uchazeče si můžeš přidávat ručně. Větší množství uchazečů, např. od personální agentury, lze do Hiringu nahrát rovnou <b> z dodané tabulky (Excel nebo CSV).</b>',
//         position: 'top',
//         showButtons: true,
//     },
//
// },
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: 'Super práce!',
        description: 'Objev svůj archiv talentů (1 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Ano, pokračovat dál',
        nextBtnText: 'Rozumím',        // Next button text for this step
        prevBtnText: 'Zpět',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/talentpool#guide");

    }
},
]



export default hiringSteps
